export interface JwtToken {
  aud: string;
  iss: string;
  iat: number;
  nbf: number;
  exp: number;
  aio: string;
  amr: string[];
  family_name: string;
  given_name: string;
  ipaddr: string;
  name: string;
  nonce: string;
  oid: string;
  onprem_sid: string;
  roles: string[];
  sub: string;
  tid: string;
  unique_name: string;
  upn: string;
  uti: string;
  ver: string;
}

export class JwtHelper {
  public parse(encodedToken: string): JwtToken {
    if (!encodedToken) {
      return null;
    }
    let base64Url = encodedToken.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  public checkTokenDetails(token: string): void {
    //this space intentionally left blank
  }
}

export default new JwtHelper();
